export default {
  "backward-and-navbar": () => import("/root/vs2-front/layouts/backwardAndNavbar.vue").then(m => m.default || m),
  "backward-auth": () => import("/root/vs2-front/layouts/backwardAuth.vue").then(m => m.default || m),
  navbar: () => import("/root/vs2-front/layouts/navbar.vue").then(m => m.default || m)
}